import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { css } from 'glamor';
import Mailto from 'react-mailto';
import Twitter from 'react-icons/lib/io/social-twitter-outline';
import Instagram from 'react-icons/lib/io/social-instagram-outline';
import Email from 'react-icons/lib/io/ios-email-outline';
// import Sad from 'react-icons/lib/io/sad-outline';

import Animated from '../components/Animated';

import {
  textContainer,
  shadowless,
  wrapper,
  quarterWidth,
  fullWidthSm,
} from '../styles';

const squareGrid = css({
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '25vw',
  '@media(max-width: 48em)': {
    height: '50vw',
  },
});

const button = {
  ...shadowless,
  ...quarterWidth,
  ...fullWidthSm,
  ...squareGrid,
};

class Contact extends Component {
  componentWillMount() {
    this.props.loadTheme();
  }

  render() {
    const { colors } = this.props.theme;
    return (
      <div>
        <Helmet
          title="Contact lucastswick"
          description="Use lucastswick's contact details to reach him in times of emergency. Or just to say hi."
        />
        <div {...textContainer}>
          <Animated as="h1">Contact Me</Animated>
          <Animated>
            If you live in Portland, I'm always down to grab a coffee! DM me on{' '}
            <a
              {...shadowless}
              target="_blank"
              rel="nofollow noopener noreferrer"
              href="https://twitter.com/lucastswick"
            >
              twitter
            </a>{' '}
            and we'll make it happen.
          </Animated>
          <div {...wrapper}>
            <Mailto
              email="lucas@generativeartist.com"
              obfuscate={true}
              {...button}
              {...css({ background: colors[1], color: 'white' })}
              target="_blank"
            >
              <Email color="white" size={90} />
              Email me
            </Mailto>
            <a
              {...button}
              {...css({ background: colors[2], color: 'white' })}
              target="_blank"
              rel="nofollow noopener noreferrer"
              href="https://twitter.com/lucastswick"
            >
              <Twitter color="white" size={90} />
              Tweet at me
            </a>
            <a
              {...button}
              {...css({ background: colors[3], color: 'white' })}
              target="_blank"
              rel="nofollow noopener noreferrer"
              href="https://instagram.com/lucastswick"
            >
              <Instagram color="white" size={90} />
              Instaboodle
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/Contact.js